import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
import { POPUP_NAMES, POPUP_CITIES } from '../lib/constants';
interface PopupData {
  name: string;
  city: string;
  minutes: number;
}
function randomFrom<T>(arr: T[]): T {
  return arr[Math.floor(Math.random() * arr.length)];
}
// Recurring social-proof toast: "X de [ciudad] acaba de comprar".
export function PurchasePopup() {
  const [data, setData] = useState<PopupData | null>(null);
  useEffect(() => {
    let hideTimer: ReturnType<typeof setTimeout>;
    const show = () => {
      setData({
        name: randomFrom(POPUP_NAMES),
        city: randomFrom(POPUP_CITIES),
        minutes: Math.floor(Math.random() * 12) + 1
      });
      hideTimer = setTimeout(() => setData(null), 5000);
    };
    const first = setTimeout(show, 4000);
    const interval = setInterval(show, 13000);
    return () => {
      clearTimeout(first);
      clearTimeout(hideTimer);
      clearInterval(interval);
    };
  }, []);
  return <div className="pointer-events-none fixed bottom-4 left-3 right-3 z-50 flex justify-center sm:left-4 sm:right-auto sm:justify-start" data-id="element-141">
      <AnimatePresence data-id="element-142">
        {data && <motion.div key={`${data.name}-${data.city}-${data.minutes}`} initial={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 24,
        scale: 0.95
      }} transition={{
        duration: 0.3
      }} className="pointer-events-auto flex w-full max-w-xs items-start gap-3 rounded-xl border border-[#c8a24a]/40 bg-white p-3 shadow-xl" data-id="element-143">
            <CheckCircle2Icon className="mt-0.5 h-6 w-6 flex-none text-emerald-600" aria-hidden="true" data-id="element-144" />
            <div className="min-w-0 flex-1" data-id="element-145">
              <p className="text-sm font-bold text-[#0b2545]" data-id="element-146">
                {data.name} de {data.city}
              </p>
              <p className="text-xs text-slate-600" data-id="element-147">
                acaba de comprar el Pack PER
              </p>
              <p className="mt-0.5 text-[11px] text-slate-400" data-id="element-148">
                hace {data.minutes} min · Compra verificada
              </p>
            </div>
            <button type="button" onClick={() => setData(null)} aria-label="Cerrar aviso" className="flex-none text-slate-400 hover:text-slate-600" data-id="element-149">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-150" />
            </button>
          </motion.div>}
      </AnimatePresence>
    </div>;
}